/* @flow */

import { identity } from 'ramda';
import { useSelector } from 'react-redux';

import type { State } from 'src/shared/core/type/reduxTypes';

export default function useReduxState(): State {
  return useSelector(identity);
}
